import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import PartnersPage from "../modules/Partners/PartnersPage";

export function Partners() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "partners-page-title",
    defaultMessage: "Partners"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <PartnersPage/>;
}
